import { useState } from "react";
import { useGetUserDataQuery } from "entities/user";
import { PencilIcon, formStyles } from "shared/ui";
import { TwoFactorAuthList } from "features/two-factor-auth";
import { ProfileField } from "./ProfileField";
import { ProfileAvatar } from "./ProfileAvatar";
import { ProfileModal, ProfileModals } from "./ProfileModals";

import styles from "./UserProfile.module.css";

const NOT_PROVIDED = "Not provided";

export const UserProfile = () => {
  const { data, isLoading } = useGetUserDataQuery();
  const [modal, setModal] = useState<ProfileModal>(null);

  const openEditNames = () => setModal("names");
  const closeModal = () => setModal(null);

  return (
    <>
      {isLoading && (
        <div className={styles.loading}>
          <div className={styles.spinner} />
          Loading...
        </div>
      )}
      {data && (
        <div className={styles.profile}>
          <ul className={styles.list}>
            <ProfileField label="User ID:" editable={false}>
              {data.account.id}
            </ProfileField>
            {data.login_email.is_synthetic ? (
              <li className={styles.listItem}>
                <p>Sign in with Google/Twitter/…</p>
              </li>
            ) : (
              <ProfileField
                label="Email:"
                editable={data.contact_email.editable}
                onClick={() => setModal("email")}
              >
                {data.contact_email.value ||
                  data.contact_email.pending ||
                  NOT_PROVIDED}
              </ProfileField>
            )}
            <ProfileField
              label="Username:"
              editable={data.display_name.editable}
            >
              {data.display_name.username}
            </ProfileField>
            <ProfileField
              label="First Name:"
              editable={data.legal_name.editable}
              onClick={openEditNames}
            >
              {data.legal_name.first_name || NOT_PROVIDED}
            </ProfileField>
            <ProfileField
              label="Last Name:"
              editable={data.legal_name.editable}
              onClick={openEditNames}
            >
              {data.legal_name.last_name || NOT_PROVIDED}
            </ProfileField>
            <ProfileField label="Tier:">
              {data.account.tier.tier_display_name}
            </ProfileField>
            <li className={styles.listItem}>
              <p className={styles.label}>2FA:</p>
              <TwoFactorAuthList />
            </li>
            <ProfileAvatar avatar={data.avatar} />
            {data.auth.can_change_password && (
              <li className={styles.listItem}>
                <button
                  type="button"
                  className={`${formStyles.outlineButton} ${formStyles.accent}`}
                  onClick={() => setModal("password")}
                >
                  <PencilIcon
                    className={formStyles.buttonIcon}
                    fill="currentColor"
                  />
                  Change password
                </button>
              </li>
            )}
          </ul>
          <ProfileModals modal={modal} profile={data} onClose={closeModal} />
        </div>
      )}
    </>
  );
};
